import { render } from "./PersonCard.vue?vue&type=template&id=70d314ea&scoped=true&ts=true"
import script from "./PersonCard.vue?vue&type=script&lang=ts"
export * from "./PersonCard.vue?vue&type=script&lang=ts"

import "./PersonCard.vue?vue&type=style&index=0&id=70d314ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70d314ea"]])

export default __exports__